// 브라우저의 쿠키 / 스토리지 사용 가능 여부 감지 유틸.
//
// Windows Edge "사이트에서 쿠키 데이터를 저장하고 읽도록 허용" OFF, 그룹정책(GPO),
// 쿠키 전체 차단, 강력 추적 방지 등으로 막히면:
//   - 쿠키 차단 → 인증(_CK 쿠키 기반)이 동작하지 않아 로그인 자체가 불가능
//   - DOM Storage 차단 → window.localStorage 속성 접근만으로 SecurityError 발생
// 위 경우를 흰 화면(크래시) 대신 사용자가 해결할 수 있는 안내로 전환하기 위한 감지 함수들.

// 쿠키 저장/읽기 가능 여부.
// navigator.cookieEnabled는 환경에 따라 부정확할 수 있어 실제 write/read 테스트로 확인한다.
export const isCookieAvailable = () => {
  try {
    if (typeof navigator !== "undefined" && navigator.cookieEnabled === false) {
      return false;
    }

    const key = "__livee_cookie_test";
    document.cookie = `${key}=1; path=/; SameSite=Lax`;
    const ok = document.cookie.indexOf(`${key}=1`) !== -1;
    // 테스트 쿠키 정리
    document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    return ok;
  } catch (e) {
    return false;
  }
};

// localStorage 사용 가능 여부.
// DOM Storage 비활성 환경에서는 window.localStorage 게터 접근 자체가 throw하므로 try/catch 필수.
export const isLocalStorageAvailable = () => {
  try {
    const key = "__livee_ls_test";
    window.localStorage.setItem(key, "1");
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

// 로그인 자체가 불가능한 치명적 차단 여부 = 쿠키 차단.
// (localStorage만 막힌 경우는 try/catch 방어로 앱이 동작하므로 차단 화면을 띄우지 않는다.)
export const isBrowserStorageBlocked = () => {
  return !isCookieAvailable();
};
